import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const RegisterModel = () => {
  return (
    <div className="register-model">
      <div className="success-img">
        <FaCheckCircle />
      </div>
      <div className="register-message">
        Registration Request Sent successfully
      </div>
      <div className="register-para">
        Please wait for the admin to activate your account. Once activated, you
        will be able to log in and explore the prices.
      </div>
    </div>
  );
};

export default RegisterModel;
